enum AddressStatus {
  ACTIVE = "ACTIVE",
  CLOSED = "CLOSED",
}

export default AddressStatus;
